// ABOUTME: Local boolean toggle switch — adapter used because Fundamental's Switch requires Formik context.
// ABOUTME: Accessible (role="switch") on/off control styled with Tailwind theme tokens; used by QuantityForm.
import React from 'react'

export interface ToggleSwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  'aria-label'?: string
  'data-cy'?: string
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  'aria-label': ariaLabel,
  'data-cy': dataCy,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    data-cy={dataCy}
    className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${
      checked ? 'bg-primary' : 'bg-border_highlight_10'
    } ${disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer'}`}
  >
    <span
      className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
        checked ? 'translate-x-5' : 'translate-x-0.5'
      }`}
    />
  </button>
)
